<template>
    <div class="invoice">
        <el-table
                :data="tablePjData"
                height="400"
                stripe
                border
                style="width: 100%">
            <el-table-column
                    align="center"
                    prop="created_at"
                    label="申请时间"
            >
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="created_at"
                    label="发票类型"
            >
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="created_at"
                    label="抬头"
            >
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="username"
                    label="税号"
            >
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="content"
                    label="发票金额"
            >
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="created_at"
                    label="邮寄信息"
            >
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="is_reply"
                    label="申请结果"
            >
                <template slot-scope="scope">
                    <span v-if="scope.row.is_reply == 1" class='yhfType'>已回复</span>
                    <span v-else class='whfType'>未回复</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        name: "invoice",
        data() {
            return {
                // 评价列表数据
                tablePjData:[],
                // tablePjData: [
                //     {
                //         created_at: '2016-05-03',
                //         username: '王小虎',
                //         address: '上海市普陀区金沙江路 1518 弄',
                //         is_reply: 1,
                //         content: 'tsContenttsContenttsContenttsContenttsContenttsContenttsContenttsContenttsContenttsContent',
                //         zhuangtaiText: '申述中'
                //     },
                //     {
                //         created_at: '2016-05-02',
                //         username: '王小虎',
                //         address: '上海市普陀区金沙江路 1518 弄',
                //         is_reply: 2,
                //         content: 'tsContenttsContenttsContenttsContenttsContenttsContenttsContenttsContenttsContenttsContent',
                //         zhuangtaiText: '申述'
                //     },
                // ],
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/persondata/children/invoice.vue